<template>
  <div id="advance-checkin" style="z-index:5" class="pos-fixed">
    <div
      class="overlay innerDivPosition"
      style="background: rgba(0, 0, 0, 0.55);"
      v-on:click.stop.prevent="hide()"
    >
    <!-- start watching and continue watching  -->
      <div
        id="innerDiv"
        class="innerDiv"
        :style="{
          backgroundImage:
            'url(' + asset('advancecheckin/Idle.png') + ')'
        }"
        v-on:click.stop.prevent
        v-if="showWatchAndEarn"
      >
        <div id="WE" class="WE">
          Watch &amp; Earn
        </div>
        <div style="padding: 0px 24px;">
          <p class="ptag">
            {{`Watch ${checkin_Data.total_events} videos and earn daily Bumper prize every 7th day!`}}
          </p>
        </div>
        <div class="nestedDiv">
          <div>
            <p style="font-size: large;">
              Day {{checkin_Data.streak==0?'1':checkin_Data.streak}}
            </p>
            <div class="winprice">
              <img class="rewardImage" :src="checkin_Data.currency_icon_url" />
              <div style="font-size: 20px;">
                {{ checkin_Data.todays_reward }}
              </div>
            </div>
            <div>
              <p style="color: #0000008f;">{{!showContinueWatching?`Complete your ${checkin_Data.total_events} Videos Today`:`You have completed ${checkin_Data.events_done}/${checkin_Data.total_events} videos`}}</p>
            </div>
            <button class="startbutton" v-on:click.stop.prevent="hide()">{{showContinueWatching?'Continue watching':'Start Watching'}}</button>
          </div>
        </div>
        <div class="streak">
          <div v-for="i in checkin_Data.total_streak" style="position: relative;">
            <div
              style="color:white;
                  display:flex;
                  align-items: center;
                      width:max-content;"
            >

              <div
                style="
                          padding:16px;
                          border-radius: 25px;
                          font-weight: 400;
                          border-width: thin;
                          display: flex;"
                          :style="{ 'border-style': i!=checkin_Data.streak?'dashed':'solid'}"
              >
              
            <img v-if="i<checkin_Data.streak" class="rewardImage" src="@/assets/advancecheckin/Checkedin.png" style="filter: contrast(6.5);"/>

                Day {{ i }}
              </div>
              <div v-if="i!=checkin_Data.total_streak" >
                <p>-</p>
              </div>
            </div>
            <div
              style="color:white;font-weight: 100;margin-top: 5px;padding-right: 10px;"
              :style="[
                !isshowPrice(i).ishown
                  ? { visibility: 'hidden' }
                  : { visibility: 'visible' }
              ]"
            >
              <img
                class="rewardImage"
                :src="checkin_Data.currency_icon_url"
                style="padding-right:2px"
              />
              <span>{{isshowPrice(i).maxprice}}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- congratulations  -->
      <div
      
        id="innerDiv"
        class="congratulatioonDiv"
        :style="{
          backgroundImage:
            'url(' + asset('advancecheckin/Success.png') + ')'
        }"
         v-else-if="showCongratulation"
      >
        <div id="WE" class="WE">
          Congratulations!
        </div>
        <div style="padding: 0px 24px;">
          <p class="ptag">
            You have earned for watching 5 videos 
          </p>
        </div>
          <div>
            <div class="winprice" style="background-color: aliceblue;">
              <img class="rewardImage" :src="checkin_Data.currency_icon_url" />
              <div style="font-size: 20px;">
                {{ checkin_Data.todays_reward }}
              </div>
            </div>
           
          </div>
         
        <div class="streak" style="margin-top: 20px;">
          <div v-for="i in checkin_Data.total_streak">
            <div
              style="color:white;
                  display:flex;
                  align-items: center;
                      width: max-content;"
            >
              <div
                style="
                          padding:16px;
                          border-radius: 25px;
                          font-weight: 400;
                          border-width:thin;
                          display: flex;"
                          :style="{ 'border-style': i!=checkin_Data.streak?'dashed':'solid'}"
              >
              <img v-if="checkin_Data.checked_in && checkin_Data.streak>i" class="rewardImage" src="@/assets/advancecheckin/Checkedin.png" style="filter: contrast(6.5);"/>
                Day {{ i }}
              </div>
              <div v-if="i!=checkin_Data.total_streak">
                <p>-</p>
              </div>
            </div>
            <div
              style="color:white;font-weight: 100;padding: 5px;padding-right: 10px;"
              :style="[
                !isshowPrice(i).ishown
                  ? { visibility: 'hidden' }
                  : { visibility: 'visible' }
              ]"
            >
              <img
                class="rewardImage"
                :src="checkin_Data.currency_icon_url"
                style="padding-right:2px"
              />
              <span>{{isshowPrice(i).maxprice}}</span>
            </div>
          </div>
        </div>
        <button  v-on:click.stop.prevent="onClaimClick()" class="claimButton">Claim Coin</button>
      </div>
     
      <!-- woohoo -->
      <div
        id="innerDiv"
        class="innerDiv"
        :style="{
          backgroundImage:
            'url(' + asset('advancecheckin/Info.png') + ')'
        }"
          v-else-if="showWooohoo"
      >
        <div id="WE" class="WE">
          Woohoo
        </div>
        <div style="padding: 0px 24px;">
          <p class="ptag">
            You claimed<br>
           
             <p style="   display: flex;
    align-items: center;
    justify-content: center;"><img class="rewardImage" :src="checkin_Data.currency_icon_url" />
              
              <span style="color:white">{{ checkin_Data.todays_reward }}</span></p> 
              
            

          </p>
          <div style="border-style: hidden;
                      padding: 5px;
                      border-radius: 20px;
                      background-color:rgba(249, 249, 249, 0.19);
                      height: 50px;
                      width: 211px;
                      margin-left: 25px;">
            <p style="color:white;padding: 0px 5px;">use coins while placing your order </p>
          </div>
        </div>
        <div class="woohooinnerDiv" v-if="checkin_Data.streak>0 && checkin_Data.streak<checkin_Data.total_streak">
          <div>
            <p style="font-size: small;">
              Bumper reward<br> every 7th Day!
            </p>
            <div class="winprice" style="background-color: antiquewhite;">
              <img class="rewardImage" :src="checkin_Data.currency_icon_url" />
              <div style="font-size: 20px;">
                {{ checkin_Data.todays_reward }}
              </div>
            </div>
            <div>
              <p style="color: #0000008f;font-size: small;">if you miss a day, <br>You have to start again</p>
            </div>
            
          </div>
        </div>
        <div class="woohooinnerDiv" style="height:50px" v-if=" checkin_Data.streak==checkin_Data.total_streak ">
          <div>
            <p style="font-size: small;width: 173px;
    margin-left: 20px;">
              visit tomorrow to earn again
            </p>
          </div>
        </div>
        <button class="startbutton" style=" background-color : transparent;
                                            border-style: solid;
                                            border-color: aliceblue;
                                            margin-top: 18px;
                                            width: 218px ; "
                                            v-on:click.stop.prevent="postmessage()">
    Continue Watching
    
  </button>
      </div>

       <!-- streak broken -->
       <div
        id="innerDiv"
        class="innerDiv"
        :style="{
          backgroundImage:
            'url(' + asset('advancecheckin/Warning.png') + ')'
        }"
          v-else-if="false"
      >
        <div id="WE" class="WE">
          OOPs!
        </div>
        <div style="padding: 0px 24px;">
          <p class="ptag">
            You broke daily streak <br>
           Dont worry,<br>
            you can still earn
          </p>
        </div>
        <div class="nestedDiv">
          <div>
            <p style="font-size: large;">
              Day 1
            </p>
            <div class="winprice">
              <img class="rewardImage" :src="checkin_Data.currency_icon_url" />
              <div style="font-size: 20px;">
                {{ checkin_Data.todays_reward }}
              </div>
            </div>
            <div>
              <p style="color: #0000008f;">Complete your 5 Videos Today</p>
            </div>
            <button class="startbutton">Start Watching</button>
          </div>
        </div>
        <div class="streak">
          <div v-for="i in checkin_Data.total_streak">
            <div
              style="color : white;
                  display: flex;
                  align-items: center;
                      width: max-content;"
            >
              <div
                style="border-style: solid;
                          padding: 16px;
                          border-radius: 25px;
                          font-weight: 400;
                          border-width: thin;"
              >
                Day {{ i }}
              </div>
              <div v-if="i!=checkin_Data.total_streak">
                <p>-</p>
              </div>
            </div>
            <div
              style="color:white;font-weight: 100;padding: 5px;padding-right: 10px;"
              :style="[
                !isshowPrice(i).ishown
                  ? { visibility: 'hidden' }
                  : { visibility: 'visible' }
              ]"
            >
              <img
                class="rewardImage"
                :src="checkin_Data.currency_icon_url"
                style="padding-right:2px"
              />
              <span>{{isshowPrice(i).maxprice}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { asset } from "@/utils/asset";
import { globals } from "@/mixins/globals";
import axios from "axios";
export default {
  mixins: [globals],

  data() {
    return {
      checkin_Data: {},
      milestoneValueArray: [],
      claimButton:false
    };
  }, 
  methods: {
    getAdvanceCheckinInfo() {
      var url = this.$store.getters.flyyDomain+"/custom_checkin_data";
      var headers = this.$store.getters.headers;
      var options = {
        method: "get",
        url: url,
        headers: headers
      };
      axios(options)
        .then(resp => {
          this.checkin_Data = { ...resp.data.checkin_data };
        })
        .catch(err => {
          console.log("advance check error!");
        });
    },
    isshowPrice(value) {
    var obj=  this.checkin_Data.milestones.find((currentitem)=>{
        return currentitem.value==value;
      })
      return {'ishown':obj?true:false,'maxprice':obj?obj.max_price:''}
    },
    hide(){
    var element=document.getElementById('advance-checkin')
    if(element){
      element.style.display="none"
    }
    this.postmessage()
  },
  onClaimClick(){
    
    this.claimButton=true
    localStorage.setItem('claim',JSON.stringify(this.claimButton))
   
  },
  postmessage(){
    window.parent.postMessage('advanceCheckinClose','*')
  }
    
  },
  computed:{
    showWatchAndEarn:function(){
      return  this.checkin_Data.events_done<this.checkin_Data.total_events && !this.checkin_Data.streak_broken
    },
    showContinueWatching:function(){
     if(this.checkin_Data.events_done>0 && this.checkin_Data.events_done<this.checkin_Data.total_events){
          return true
      }else{
        return false
      }
    },
    showCongratulation:function(){
      return (this.checkin_Data.events_done==this.checkin_Data.total_events && !this.claimButton)
    },
    showWooohoo:function(){
      return this.checkin_Data.events_done==this.checkin_Data.total_events && this.claimButton
    }
  },
  
 
  created() {
    this.getAdvanceCheckinInfo();
    var date=new Date().getDate();
    var month=new Date().getMonth();
    var year=new Date().getFullYear()
    if(localStorage.getItem('todayDate')){
      
      if(localStorage.getItem('todayDate')!=`${date}/${month}/${year}`){
        localStorage.removeItem('todayDate')
        localStorage.removeItem('claim')
        localStorage.setItem('todayDate',`${date}/${month}/${year}`)
        localStorage.setItem('claim',JSON.parse(this.claimButton))
        this.claimButton=JSON.parse(localStorage.getItem('claim'))
      }else{
        this.claimButton=JSON.parse(localStorage.getItem('claim'))
      }
      
    }else{
        localStorage.setItem('todayDate',`${date}/${month}/${year}`)
        localStorage.setItem('claim',JSON.stringify(this.claimButton))
        this.claimButton=JSON.parse(localStorage.getItem('claim'))
      }
 
  }
};
</script>
<style>
.myheader {
  -moz-osx-font-smoothing: grayscale;
  position: fixed;
  width: inherit;
  background-color: white;
  margin-top: -17px;
  padding: 7px;
  height: 30px;
}
.innerDiv {
  width: 320px;
    border-radius: 16px;
    height: 532px;
    border-style: hidden;
    z-index: 20000;
    background-size: cover;
    background-repeat: no-repeat;
}
.innerDivPosition {
  display: flex;
  align-items: center;
  justify-content: center;
}
.WE {
  color: white;
  font-family: inherit;
  margin: auto;
  margin-top: 60px;
  font-size: 20px;
  font-weight: 400;
}
.ptag {
  font-size: 13px;
  color: white;
  font-family: sans-serif;
  font-weight: 500;
  margin-top: 25px;
}
.nestedDiv {
  width: 200px;
  height: 230px;
  border-style: solid;
  border-color: aliceblue;
  margin: auto;
  border-radius: 14px;
  background-color: white;
}
.winprice {
  width: 175px;
  border-radius: 21px;
  height: 55px;
  border-style: solid;
  margin: auto;
  border-color: burlywood;
  display: flex;
  justify-content: center;
  align-items: center;
}
.startbutton {
  padding: 10px;
  border-radius: 12px;
  border-style: hidden;
  background-color: #2020a8c7;
  color: white;
  width: 173px;
  font-size: medium;
}
.streak {
  margin-top: 14px;
  margin-left: 30px;
  padding: 0px 17px;
  display: flex;
  align-items: center;
  overflow-x: scroll;
  scrollbar-width: none;
}
.borderstyle {
  border-style: solid;
  padding: 16px;
  border-radius: 25px;
  font-weight: 400;
  border-width: thin;
}
.rewardImage {
  width: 17px;
  height: 18px;
  padding-right: 10px;
}
.congratulatioonDiv{
  width: 320px;
    border-radius: 16px;
    height: 530px;
    border-style: hidden;
    z-index: 20000;
    background-size: cover;
    background-repeat: no-repeat;
}
.claimButton {
    padding: 10px;
    border-radius: 12px;
    border-style: solid;
    background-color: transparent;
    color: white;
    width: 173px;
    font-size: medium;
    border-color: white;
    margin-top: 20px;
}
.woohooinnerDiv{
  width: 219px;
    height: 182px;
    border-style: solid;
    border-color: aliceblue;
    margin: auto;
    border-radius: 14px;
    background-color: white;
    margin-top: 15px;
    /* background-color: #faebd79c; */
}
</style>
